import React from 'react';

import List from '../List';
import Link from '../Link';
import SvgIcon from '../SvgIcon';
import Dropdown from '../Dropdown'
import Loader from '../Loader';
import LoginDropdown from '../LoginDropdown';

const OfflineActions = ({ spacing, showIconOnly, availableOffline, isLoggedIn, onClickAddToOffline, onClickRemoveFromOffline, disabled, isSavingOffline, t, openAuthModal, align, rpOffline, saveOfflineText, deleteOfflineText, isRtl , icon, loginText }) => {
  let title = '';
  if(rpOffline){
    title = availableOffline ? deleteOfflineText : saveOfflineText;
  }
  else {
    title = availableOffline ? t('SvgTitle.bin') : t('SvgTitle.offline');
  }
  let iconName = icon ? icon : "offline"
  if (disabled) {
    return (
      <Dropdown
        toggleEl={<Link><SvgIcon name={iconName} title={t('SvgTitle.offline')} size="m" pushRight isRtl={isRtl}/>{showIconOnly ? null : t('Book.add-to-offline')}</Link>}
        minWidth="l"
        isContentRtl={isRtl}
        align="left"
      >
        <List nowrap spacing={spacing}>
          <Link fullWidth legend={t('Book.please-upgrade-browser-add-story-to-offline')} 
            onClick={openAuthModal}>
            <SvgIcon name="user" title={t('SvgTitle.user')}/> {t('global.upgrade-browser')}
          </Link>
        </List>
      </Dropdown>
    )
  } else {
    if (isLoggedIn) {
      const iconEl = isSavingOffline
                      ?
                      <Loader />
                      :
                      <SvgIcon name={availableOffline ? 'bin' : iconName} title={title} pushRight isRtl={isRtl}/>
      const descEl = availableOffline ? t('Book.remove-from-offline') : t('Book.add-to-offline')
                      
      return (
        <List inline spacing={spacing}>
          <Link
            onClick={availableOffline ? onClickRemoveFromOffline : onClickAddToOffline}
            theme={availableOffline ? 'danger' : null}
            disabled={isSavingOffline}
          >
          {iconEl}
          {" "}
          { showIconOnly
            ?
            null
            :
            descEl}
          </Link>
        </List>
      )
    } else {
      if (availableOffline) {
        return (
          <List inline spacing={spacing}>
            <Link
              onClick={onClickRemoveFromOffline}
              theme="danger"
            >
              <SvgIcon name="bin" title={t('SvgTitle.bin')} pushRight isRtl={isRtl}/> {showIconOnly ? null : t('Book.remove-from-offline')}
            </Link>
          </List>
        )
      } else {
        return (
          <Dropdown
            toggleEl={<Link><SvgIcon name={iconName} title={t('SvgTitle.offline')} size="m" pushRight />{showIconOnly ? null : t('Book.add-to-offline')}</Link>}
            minWidth="l"
            isContentRtl={isRtl}
            align={align || "left"}
          >
            <List nowrap spacing={spacing}>
              <LoginDropdown LoginText={loginText || t('Book.please-log-in-add-story-to-offline')} onClickLogin={ openAuthModal } />
            </List>
          </Dropdown>
        )
      }
    }
  }
};

export default OfflineActions;



// WEBPACK FOOTER //
// ./src/components/Book/OfflineActions.jsx